import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const mobileView = css`
  display: block;
  background-color: ${colors.black100};
  min-height: 100vh;

  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const contentContainer = css`
  padding: ${spacing(2, 2)};
  padding-top: 140px; /* Account for fixed header height */
  padding-bottom: ${spacing(
    18
  )}; /* Increased padding for larger 2x bottom navigation */
  background-color: ${colors.black100};
`

export const desktopView = css`
  display: block;
  padding-top: ${spacing(1)};

  ${MQ.TABLETS} {
    display: none;
  }
`

export const desktopHeader = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${spacing(2)};
  flex-wrap: wrap;
  margin-bottom: ${spacing(2)};
`

export const desktopHeaderTitle = css`
  flex: 0 0 220px;
`

export const desktopHeaderFilters = css`
  flex: 1 1 640px;
  min-width: 0;
`

export const desktopTableSection = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
`

export const cardsContainer = css`
  display: flex;
  flex-direction: column;
`

export const emptyState = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(6, 2)};
`

export const emptyText = css`
  color: ${colors.white60};
  text-align: center;
`

export const loadingMore = css`
  margin-top: ${spacing(2)};
  padding: ${spacing(2, 0)};
`

export const loadingPlaceholder = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(2)};
`

export const loadingText = css`
  color: ${colors.white60};
  text-align: center;
`

export const debugInfo = css`
  margin-top: ${spacing(2)};
  padding: ${spacing(2, 0)};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const debugText = css`
  color: ${colors.white40};
  text-align: center;
  font-size: 10px;
  opacity: 0.8;
`
